export default __webpack_public_path__ + "src/images/galleries/0/menu_cn-966cba.png";